import { createSlice } from "@reduxjs/toolkit";

export const get_blogs = createSlice({
  name: "blogs_contents",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreBlogs: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    removeBlogById: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.data];
      state.value.data.forEach((item, index) => {
        if (action.payload === item.id) {
          existingData.splice(index, 1);
        }
      });
      state.value.data = existingData;
    },
  },
});

export const { updateStoreBlogs, removeBlogById } = get_blogs.actions;

export default get_blogs.reducer;
